import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { getFeatureFlags } from '../api/system'

/**
 * 功能开关（Feature Flag）全局状态。
 * 由后端 /api/system/feature 提供，登录后加载一次；管理端切换后调用 load() 刷新。
 */
export const useFeatureStore = defineStore('feature', () => {
  const creditEnabled = ref(false)
  const phoneEnabled = ref(false)
  const loaded = ref(false)

  const load = async () => {
    try {
      const flags = await getFeatureFlags()
      creditEnabled.value = flags.creditEnable === true
      phoneEnabled.value = flags.phoneEnable === true
    } catch {
      creditEnabled.value = false
      phoneEnabled.value = false
    } finally {
      loaded.value = true
    }
  }

  const ensureLoaded = async () => {
    if (!loaded.value) await load()
  }

  const setCreditEnabled = (value: boolean) => {
    creditEnabled.value = value
    loaded.value = true
  }

  const isCreditVisible = computed(() => creditEnabled.value)

  return {
    creditEnabled,
    phoneEnabled,
    loaded,
    isCreditVisible,
    load,
    ensureLoaded,
    setCreditEnabled,
  }
})
